import createAxiosInstance from '@/utils/requset'

const apiInstances = {
    api1: createAxiosInstance('api1'),
    api2: createAxiosInstance('api2'),
};


//他的首页
export function otherIndex(parameter) {
    return apiInstances.api1({
        url: '/v1/other_center/index',
        method: 'get',
        params: parameter
    })
}

//他的作品
export function otherWorkList(parameter) {
    return apiInstances.api1({
        url: '/v1/other_center/work_list',
        method: 'get',
        params: parameter
    })
}

//他的订阅
export function otherSub(parameter) {
    return apiInstances.api1({
        url: '/v1/other_center/sub_list',
        method: 'get',
        params: parameter
    })
}

//他的关注
export function otherFocus(parameter) {
    return apiInstances.api1({
        url: '/v1/other_center/focus_list',
        method: 'get',
        params: parameter
    })
}

//他的粉丝
export function otherFans(parameter) {
    return apiInstances.api1({
        url: '/v1/other_center/fans_list',
        method: 'get',
        params: parameter
    })
}

//订阅漫画
export function subscribe(data) {
    return apiInstances.api2({
        url: `/app/v1/comic/sub/add?comic_id=` + data,
        method: 'post',
        data: data
    })
}